// extracted by mini-css-extract-plugin
export default {"cats":"CatsList_cats__NdB6l"};